/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { RestoreJob } from '../models/RestoreJob';

export class GetRestoreJobResponse {
  'job': RestoreJob;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "job",
      "baseName": "job",
      "type": "RestoreJob",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return GetRestoreJobResponse.attributeTypeMap;
  }

  public constructor() {
  }
}

